import React, { useEffect, useState } from 'react';
import LangStorageManager from '../lang/LangStorageManager';
import LanguageManager from '../lang/LanguageManager';
import './skills.css';

export default function Skills({ skills }) {
    const storage = new LangStorageManager(null);
    const[language, setLanguage] = useState(storage.getStorage());
    const[texts, setTexts] = useState(null);

    useEffect(() => {
        const loadText = async () => {
            const translator = new LanguageManager(storage.getStorage());
            await translator.loadTranslation();
            setTexts(translator.getAll());
        };
        loadText();
    }, [language]);
    
    return (
        <section id="skills">
            <h2>{texts?.skill?.title || 'My Technical Skills'}</h2>
            {Object.entries(skills).map(([category, images]) => (
                <div key={category} className="skills-category">
                    <h3>{category}</h3>
                    <div className="images-container">
                        {images.map((image, index) => (
                            <img key={index} src={`/img/skill/${image}.png`} alt={image} title={image} />
                        ))}
                    </div>
                </div>
            ))}
        </section>
    );
}